import Button from "@mui/material/Button";

export const SecondaryButton = ({
  text,
  onSubmit,
  onClick,
}) => {
  return (
    <Button
      type="submit"
      variant="outlined"
      onSubmit={onSubmit}
      onClick={onClick}
      color="success"
      sx={{
        background: "#00a0a0",
        textTransform: "unset",
        letterSpacing: "0.8px",
        color: "#fff",
        "&:hover": {
          color: "#00a0a0",
        },
      }}
    >
      {text}
    </Button>
  );
};

export const SecondaryWhiteButton = ({
  text,
  onSubmit,
}) => {
  return (
    <Button
      type="submit"
      variant="outlined"
      onSubmit={onSubmit}
      sx={{
        color: "white",
        border: "1px solid #fff",
        textTransform: "unset",
        fontSize: "0.8125rem",
        fontWeight: 600,
      }}
    >
      {text}
    </Button>
  );
};
